import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { ColorsConstant } from "./colorConstant";

const ThemeContext = createContext();
function ThemeProvider({ children }) {
  const [primaryColor, setPrimaryColor] = useState('');
  const [secondaryColor, setSecondaryColor] = useState('');

  const [primaryFontText, setPrimaryFontText] = useState('');
  const [secondaryFontText, setSecondaryFontText] = useState('');

  const [primaryBg, setPrimaryBg] = useState();
  const [secondaryBg, setSecondaryBg] = useState();
  const [primaryFontColor, setPrimaryFontColor] = useState();
  const [secondaryFontColor, setSecondaryFontColor] = useState();
  const settingsData = useSelector((state) => state.settingsReducers.settingsData?.data);

  const getSettingApiData = async () => {
    try {
      setPrimaryBg(settingsData?.data?.[0] ? settingsData?.data?.[0]?.branding?.backgroundAndTextTheme?.primaryBackgroundColor : ColorsConstant.defaultBlue)
      setSecondaryBg(settingsData?.data?.[0] ? settingsData?.data?.[0]?.branding?.backgroundAndTextTheme?.secondaryBackgroundColor : ColorsConstant.defaultBlue)
      setPrimaryFontColor(settingsData?.data?.[0] ? settingsData?.data?.[0]?.branding?.backgroundAndTextTheme?.primaryTextColor : ColorsConstant.white)
      setSecondaryFontColor(settingsData?.data?.[0] ? settingsData?.data?.[0]?.branding?.backgroundAndTextTheme?.secondaryTextColor : ColorsConstant.white)
    } catch (error) {
      console.error('Error - ', error.message);
    }
  };

  useEffect(() => {
    getSettingApiData();
  }, []);

  useEffect(() => {
    if(primaryBg && secondaryBg && primaryFontColor && secondaryFontColor){  
      const dynamicBgColorPrimary =  primaryBg;
      const dynamicBgColorSecondary = secondaryBg;
     
      const dynamicFontColorPrimary = primaryFontColor;
      const dynamicFontColorSecondary = secondaryFontColor;
  
      setPrimaryColor(dynamicBgColorPrimary || ColorsConstant.defaultBlue);
      setSecondaryColor(dynamicBgColorSecondary || ColorsConstant.defaultBlue);
  
      setPrimaryFontText(dynamicFontColorPrimary || ColorsConstant.white);
      setSecondaryFontText(dynamicFontColorSecondary || ColorsConstant.white);
    }
    let theme = {
      primaryBg: primaryBg, 
      secondaryBg: secondaryBg, 
      primaryFontColor: primaryFontColor,
      secondaryFontColor: secondaryFontColor
    }
    localStorage.setItem("theme", JSON.stringify(theme))
  }, [primaryBg, secondaryBg, primaryFontColor, secondaryFontColor])

  const contextValue = useMemo(
    () => ({ primaryColor, secondaryColor, primaryFontText, secondaryFontText }),
    [primaryColor, secondaryColor, primaryFontText, secondaryFontText]
  );

    // Don't render the children if the theme data is not available
  if (!primaryColor || !secondaryColor || !primaryFontText || !secondaryFontText) {
    return null;
  }

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
}

ThemeProvider.propTypes = {
  children: PropTypes.node,
};

export const useTheme = () => useContext(ThemeContext);

export default ThemeProvider;
